import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: goals.BadgeRecipient.
export default class BadgeRecipient extends Fragment {
  declare [Type]: 'goals/badge-recipient';

  // The property by which the recipient of a badge is identified.
  // This value should be an IRI mapped in the present context.
  // For example, email maps to http://schema.org/email and indicates that the identity of the IdentityObject will represent a value of a Profile’s email property.
  // "email"
  @attr('string', { defaultValue: '' })
  declare type: string;

  // Plaintext identity value
  // "alice@example.org"
  @attr('string', { defaultValue: '' })
  declare identity: string;
}
